<template>
  <LandingSection
    class="core-features"
    title="核心优势"
    desc="更专业、更高效、更可控、更易部署的 AI 视频生产能力"
    theme="dark"
  >
    <div class="core-features__grids">
      <AdvantageCard v-for="card in coreCards" v-bind="card" />
    </div>
    <ArrowBtn
      variant="purple-common"
      text="立即咨询"
      class="core-features__consult-btn"
      @click="$emit('consultClick')"
    />
  </LandingSection>
</template>

<script setup lang="ts">
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';
import AdvantageCard from '~/design/components/advantage-card/index.vue';
import IconE2E from '~/design/icons/end2end.svg?component';
import IconControl from '~/design/icons/fully-control.svg?component';
import IconEfficiency from '~/design/icons/high-efficiency.svg?component';
import IconQuality from '~/design/icons/high-quality.svg?component';
import IconMultiScenes from '~/design/icons/multi-scenes.svg?component';
import IconMultiTenant from '~/design/icons/multi-tenant.svg?component';
import LandingSection from '~/design/widgets/landing-section/cn-template.vue';

const coreCards = [
  {
    icon: IconQuality,
    title: '高质量',
    desc: '从灯光、场景，到人物形象、表现和运镜均达到专业级视频水准，成片效果媲美专业视频团队。',
  },
  {
    icon: IconEfficiency,
    title: '高效率',
    desc: '从脚本到成片仅需数秒，轻松应对大批量、高频次的内容生产需求。',
  },
  {
    icon: IconControl,
    title: '高可控',
    desc: '支持对场景、角色、音色、动作、镜头所有视频元素的任意编辑，实现视频内容的精细化控制。',
  },
  {
    icon: IconMultiTenant,
    title: '多角色',
    desc: '覆盖超写实、二次元、卡通、美型等多样角色风格和人设，满足不同内容调性与角色设定需求。',
  },
  {
    icon: IconMultiScenes,
    title: '多场景适配',
    desc: '内置海量 3D 场景、人物、音色、动作、镜头，支持自由组合搭配，满足各类视频场景需求。',
  },
  {
    icon: IconE2E,
    title: '端到端',
    desc: '从输入到成片全流程自动化，开发者无需搭建视频生产链路，即可集成标准化视频能力。',
  },
];
</script>

<style lang="scss" scoped>
.core-features {
  background: var(--x-text-1);
}
.core-features__grids {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}
.core-features__consult-btn {
  margin-top: 80px;
}
</style>
